import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  tableRow: {
    display: 'grid',
    gridTemplateColumns: '24fr 1.5fr',
    columnGap: 5,
    backgroundColor: (props: { isOdd: boolean }) =>
      props.isOdd == true
        ? theme.palette.grey[300]
        : theme.palette.background.default,
    borderRadius: 10,
    alignItems: 'center',
    paddingLeft: 12,
    transition: 'background-color 0.3s ease-in-out',
    height: 100
  },
  menuIcon: {
    justifySelf: 'end',
    marginRight: 40
  },

  tableRowExceptMenuItem: {
    display: 'grid',
    columnGap: 5,
    gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 1fr'
  }
}))

export default useStyles
